module.exports = require("@swa-ui/core/src/Content/Content.module.scss");